module.exports = __webpack_public_path__ + "img/delete.51c68b4a.svg";